let computed = require('baobab').monkey;

const ERRORS_MAP = {
    accessDenied: 'Email или пароль указаны неверно',
    invalidValidation: 'Заполните логин или пароль',
    internalError: 'Что-то пошло не так, попробуйте еще раз',
};

module.exports = {
    errorMessage (state) {
        state.set(['login', 'computed', 'error', 'text'], computed(
            ['login', 'error', 'errorType'],
            (errorType) => {
                return ERRORS_MAP[errorType];
            }
        ));
    },

    errorState (state) {
        state.set(['login', 'computed', 'error', 'isError'], computed(
            ['login', 'error', 'errorType'],
            (errorType) => errorType
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/auth/login.js